'use client'
import { createContext, PropsWithChildren, RefObject } from 'react'
import { RecoilEnv, RecoilRoot } from 'recoil'
import { ConfigProvider } from 'antd'
import { ThemeProvider } from 'next-themes'
import StyledComponentsRegistry from 'Comps/providers/AntdRegistry'
import RecoilNexus from 'recoil-nexus'
import { CharacterBadgeConfigProvider } from '@/hooks/useCharacterBadgeConfig'

RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false
export const DesktopHomeScrollContainerContext =
  createContext<RefObject<HTMLDivElement> | null>(null)
export const MobileHomeScrollContainerContext =
  createContext<RefObject<HTMLDivElement> | null>(null)
export default function Providers({ children }: PropsWithChildren) {
  return (
    <RecoilRoot>
      <RecoilNexus />
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              handleLineWidth: 0,
              handleLineWidthHover: 0,
              handleSize: 9,
              handleSizeHover: 9,
              railSize: 3,
            },
            Switch: {
              handleSizeSM: 15,
              handleSize: 20,
            },
            Button: {
              defaultActiveBorderColor: 'rgba(255, 255, 255, 0.4)',
              defaultActiveColor: 'rgba(255, 255, 255, 1)',
              defaultActiveBg: 'rgba(255, 255, 255, 0.4)',
              defaultBg: 'rgba(255, 255, 255, 0.2)',
              defaultColor: 'rgba(255, 255, 255,1)',
              defaultBorderColor: 'rgba(255, 255, 255, 0.2)',
              defaultHoverBg: 'rgba(255, 255, 255, 0.4)',
              defaultHoverColor: 'rgba(255, 255, 255, 1)',
              defaultHoverBorderColor: 'rgba(255, 255, 255, 0.4)',
            },
          },
        }}
      >
        <StyledComponentsRegistry>
          <ThemeProvider disableTransitionOnChange>
            <CharacterBadgeConfigProvider>
              {children}
            </CharacterBadgeConfigProvider>
          </ThemeProvider>
        </StyledComponentsRegistry>
      </ConfigProvider>
    </RecoilRoot>
  )
}
